import {
  Dimensions,
} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;


const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      backgroundColor: "#fff",
      height: 400,
      minHeight: "100%",
      marginLeft: 20,
      borderRadius: 12,
      width: "100%",
      marginTop: 20,
    },
    footer: {
      flexDirection: "row",
      alignSelf: "flex-end",
      width: 220,
      height: 44,
    },
    custInfoWrapper: {
      gap: 20,
      height: "80%",
      paddingTop: 10,
      paddingHorizontal: 30,
    },
    infoWrapper: {
      flexDirection: "row",
      gap: 94,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
    },
    userDetailsView: {
      display: "flex",
      marginLeft: 20,
    },

    imgContainer: {
      justifyContent: "space-evenly",
      flexDirection: "row",
      marginTop: 5,
      marginRight: 15,
      height: 70,
      borderBottomWidth: 0.5,
      borderBottomColor: "#d7dbde",
      paddingHorizontal: 5,
    },
    firstContainer: {
      width: 300,
      marginLeft: 10,
    },
    emptyRadioBtn: {
      width: 18,
      height: 18,
      marginLeft: 10,
    },
    textStyle2: {
      height: 11,
      fontSize: 9,
      fontWeight: "600",
      color: "#02122c",
    },
    honda: {
      height: 11,
      fontSize: 9,
      fontWeight: "500",
      color: "#02122c",
    },
    number: {
      height: 15,
      fontSize: 13,
      fontWeight: "bold",
      color: "#bd2d37",
      marginLeft: 3,
      width: 50,
    },
    hondaTextContainer: {
      marginRight: 20,
      height: 30,
      alignItems: "flex-start",
      marginLeft: 10,
      marginTop: 10,
      width: 100,
    },
    numberContainer: {
      flexDirection: "row",
      alignItem: "flex-start",
      justifyContent: "center",
      marginVertical: 7,
      marginLeft: 40,
    },
    flatListView: {
      height: "80%",
    },
    customButtonView: {
      width: 218,
      height: 37,
    },
    radioButtonInsideStyle: {
      height: 7,
      width: 7,
      borderRadius: 7,
      backgroundColor: "#9d1d27",
    },
    bitMap: {
      width: 51.5,
      height: 47,
      borderRadius: 10,
      backgroundColor: "#ccd0d5",
      marginVerticle: 10,
    },
    subView: {
      flexDirection: "row",
      alignItems: "flex-start",
    },
    radiobuttonOutSideStyle: {
      width: 15,
      height: 15,
      borderRadius: 10,
      borderColor: "#9d1d27",
      borderWidth: 2,
      alignItems: "center",
      justifyContent: "center",
      marginLeft: 10,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {
      userDetailsView: {
        display: "none",
      },
    },
    [DEVICE_SIZES.SM]: {
      userDetailsView: {
        display: "none",
      },
    },
    [DEVICE_SIZES.XS]: {
      infoWrapper: {
        flexDirection: "column",
        gap: 10,
      },
      custInfoWrapper: {
        // marginTop: 30
      },
      footer: {
        alignSelf: "center",
        marginTop: 30,
      },
      userDetailsView: {
        display: "none",
      },
    },
  }
);

export default useStyles;

